import { styled } from 'styled'

import ExternalLink from '../ExternalLink'
import { linkCss } from './StyledLink'

export default styled(ExternalLink).attrs(() => ({ target: '_self' }))`
  ${linkCss}
`
